export default __webpack_public_path__ + "static/media/Action.bcdf8043.svg";